"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_PENDING = exports.COMMITTED = exports.FAILED_WITH_ERROR = exports.FAILED = exports.CANCELED = exports.CONFIRMED = exports.CREATED = void 0;
exports.CREATED = 'created';
exports.CONFIRMED = 'confirmed';
exports.CANCELED = 'canceled';
exports.FAILED = 'failed';
exports.FAILED_WITH_ERROR = 'failed-with-error';
exports.COMMITTED = 'committed';
exports.UPDATE_PENDING = 'update-pending';
